{% block sw_extension_store_listing %}
    <div class="sw-extension-store-listing">
        {% block sw_extension_store_listing_loader %}
            <sw-loader v-if="isLoading" />
        {% endblock %}

        <sw-extension-store-accessibility />
        <sw-extension-store-statistics-promotion />

        {% block sw_extension_store_listing_filter %}
            <sw-extension-store-listing-filter />
        {% endblock %}

        {% block sw_extension_store_listing_grid %}
            <div class="sw-extension-store-listing__listing-grid">
                <template v-for="extension in extensions" :key="extension.id">
                    {% block sw_extension_store_listing_card %}
                        <sw-extension-listing-card :extension="extension" />
                    {% endblock %}
                </template>
            </div>
        {% endblock %}

        {% block sw_extension_store_listing_pagination %}
            <sw-pagination v-bind="{ total, page, limit }" @page-change="setPage" />
        {% endblock %}
    </div>
{% endblock %}
